import { Routes as ReactRouterRoutes, Route, Navigate } from "react-router";
import ProtectedRoute from "@/routes/ProtectedRoute.tsx";
import MobileLayout from "@/components/MobileLayout.tsx";
import AuthenticationLayout from "@/components/AuthenticationLayout.tsx";
import SignIn from "@/pages/authentication/SignIn.tsx";
import RawHtml from "@/pages/RawHtml.tsx";
import { useClient } from "@/hooks/useClient.ts";
import ForgotPassword from "@/pages/authentication/ForgotPassword.tsx";
import ResetPassword from "@/pages/authentication/ResetPassword.tsx";
import Signup from "@/pages/authentication/Signup.tsx";
import More from "@/pages/More.tsx";
import ChangePassword from "@/pages/ChangePassword.tsx";
import Support from "@/pages/Support.tsx";
import CreateSupportTicket from "@/pages/CreateSupportTicket.tsx";
import Wallet from "@/pages/wallet/Wallet.tsx";
import Notifications from "@/pages/Notifications.tsx";
import Deposit from "@/pages/wallet/Deposit.tsx";
import Withdraw from "@/pages/wallet/Withdraw.tsx";
import Profile from "@/pages/Profile.tsx";
import { isDesktop } from "react-device-detect";
import DesktopLayout from "@/components/DesktopLayout.tsx";
import Tickets from "@/pages/Tickets.tsx";
import Raffles from "@/pages/Raffles.tsx";
import RaffleDetail from "@/pages/RaffleDetail.tsx";
import NotFound from "@/pages/NotFound.tsx";
import Subscriptions from "@/pages/Subscriptions.tsx";
import Callback from "@/pages/Callback.tsx";
import { useTranslation } from "@/i18n";
import FreeTicket from "@/pages/FreeTicket.tsx";

const Index = () => {
  const client = useClient();
  const { t } = useTranslation();

  return (
    <ReactRouterRoutes>
      <Route path="signin" element={<Navigate to="/sign-in" replace />} />
      <Route element={<AuthenticationLayout />}>
        <Route path="sign-in" element={<SignIn />} />
        <Route path="sign-up" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        {/*<Route path="quiz" element={<Register />} />*/}
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={isDesktop ? <DesktopLayout /> : <MobileLayout />}>
          <Route index element={<Raffles />} />
          <Route path="raffles/:id" element={<RaffleDetail />} />
          <Route path="more" element={<More />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="free-ticket" element={<FreeTicket />} />

          <Route path="wallet">
            <Route index element={<Wallet />} />
            <Route path="deposit" element={<Deposit />} />
            <Route path="withdraw" element={<Withdraw />} />
          </Route>
          <Route path="profile" element={<Profile />} />
          <Route path="support">
            <Route index element={<Support />} />
            <Route path="create-ticket" element={<CreateSupportTicket />} />
          </Route>
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>
      </Route>

      <Route element={isDesktop ? <DesktopLayout /> : <MobileLayout />}>
        <Route
          path="terms-of-service"
          element={
            <RawHtml title={t("nav.termsOfService")} html={client!.tos} />
          }
        />
        <Route
          path="privacy-policy"
          element={
            <RawHtml title={t("nav.privacyPolicy")} html={client!.privacy} />
          }
        />
        <Route
          path="gdpr"
          element={<RawHtml title={t("nav.gdpr")} html={client!.gdpr} />}
        />
        <Route
          path="accessibility"
          element={
            <RawHtml
              title={t("nav.accessibility")}
              html={client!.accessibility}
            />
          }
        />
        <Route
          path="complaints"
          element={
            <RawHtml title={t("nav.complaints")} html={client!.complaints} />
          }
        />
        <Route path="callback" element={<Callback />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </ReactRouterRoutes>
  );
};

export default Index;
